<template>
  <div class="strategio-loading-main">
    <p>
      <v-progress-circular style="color:#00C3D7;" indeterminate size="50"></v-progress-circular>
      <br />
      <span class="strategio-loading-main-message">
        Un momento por favor
      </span>
    </p>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.strategio-loading-main {
  text-align: center;
  margin-top: 128px;
}
.strategio-loading-main-message {  
  font-weight: 500;
  font-size: 18px;
  color: black;
}

</style>


// WEBPACK FOOTER //
// src/components/custom-loading.vue